<div class="help-details-container p-4 card">
  <!-- Enhanced Header Section -->
  <div class="header-section">
    <div class="bg-primary border-round-lg p-5 mb-5">
      <div class="flex flex-column align-items-center justify-content-center">
        <h1 class="text-0 font-bold text-5xl mb-3 text-center">
          {{ helpDetails?.title }}
        </h1>
        <!-- <p class="text-0 text-xl text-center" *ngIf="helpDetails?.description">{{ helpDetails?.description }}</p> -->

        <!-- Back button for easy navigation -->
        <button pButton label="Back to Help" icon="pi pi-arrow-left" routerLink="/app/help" class="mt-3"></button>
      </div>
    </div>
  </div>

  <!-- Steps Timeline View -->
  <div class="steps-container mb-5">
    <p-timeline [value]="helpDetails?.steps" styleClass="custom-timeline" align="alternate">
      <ng-template pTemplate="marker" let-step>
        <span class="custom-marker flex align-items-center justify-content-center">
          <i class="pi pi-check" *ngIf="step.completed"></i>
          <span *ngIf="!step.completed">{{ helpDetails?.steps!.indexOf(step) + 1 }}</span>
        </span>
      </ng-template>

      <ng-template pTemplate="content" let-step>
        <p-card styleClass="step-card mb-3">
          <ng-template pTemplate="header">
            <div class="flex align-items-center p-3 bg-primary-50 border-bottom-1 border-primary-100">
              <h3 class="text-lg font-medium m-0 text-primary-900">
                {{ step.title }}
              </h3>
            </div>
          </ng-template>

          <div class="step-content p-2">
            <p class="text-700 line-height-3">
              {{ step.description }}
            </p>

            <!-- Add image if available -->
            <img *ngIf="step.imageUrl" [src]="step.imageUrl" alt="Step illustration" class="w-full border-round-lg mt-3" />

            <!-- Add any relevant links or actions -->
            <div class="flex mt-3" *ngIf="step.actionUrl">
              <a [href]="step.actionUrl" target="_blank" class="p-button p-component p-button-outlined">
                <span class="p-button-icon p-button-icon-left pi pi-external-link"></span>
                <span class="p-button-label">Learn More</span>
              </a>
            </div>
          </div>
        </p-card>
      </ng-template>
    </p-timeline>
  </div>

  <!-- Alternative Steps Card View for Mobile -->
  <div class="steps-mobile-view">
    <div class="grid">
      <div class="col-12 md:col-6 lg:col-4 p-2" *ngFor="let step of helpDetails?.steps; index as i">
        <p-card styleClass="h-full step-card-mobile">
          <ng-template pTemplate="header">
            <div class="flex align-items-center gap-3 p-3 bg-primary-50 border-bottom-1 border-primary-100">
              <div class="step-number flex align-items-center justify-content-center border-circle bg-primary text-white">
                <span>{{ i + 1 }}</span>
              </div>
              <h3 class="text-lg font-medium m-0 text-primary-900">
                {{ step.title }}
              </h3>
            </div>
          </ng-template>

          <div class="p-3">
            <p class="text-700 line-height-3">
              {{ step.description }}
            </p>

            <!-- Add image if available -->
            <!-- <img *ngIf="step.imageUrl" [src]="step.imageUrl" alt="Step illustration" class="w-full border-round-lg mt-3"> -->

            <!-- Add any relevant links or actions -->
            <!-- <div class="flex mt-3" *ngIf="step.actionUrl">
                            <a [href]="step.actionUrl" target="_blank" class="p-button p-component p-button-outlined">
                                <span class="p-button-icon p-button-icon-left pi pi-external-link"></span>
                                <span class="p-button-label">Learn More</span>
                            </a>
                        </div> -->
          </div>
        </p-card>
      </div>
    </div>
  </div>

  <!-- Additional Help or Related Content Section -->
  <!-- <div class="related-content mt-6 border-round-lg p-4 surface-card shadow-2" *ngIf="helpDetails?.relatedHelp?.length">
        <h3 class="text-xl font-medium mb-3">Related Help Topics</h3>
        <div class="grid">
            <div class="col-12 md:col-4" *ngFor="let related of helpDetails?.relatedHelp">
                <a [routerLink]="['/app/help-details', related._id]" class="no-underline">
                    <div class="p-3 border-round-lg surface-hover flex gap-2 align-items-center">
                        <i class="pi pi-info-circle text-primary"></i>
                        <span class="text-primary-900">{{ related.title }}</span>
                    </div>
                </a>
            </div>
        </div>
    </div> -->

  <!-- Feedback Quick Link -->
  <div class="feedback-link flex justify-content-center mt-6">
    <p-button label="Was this helpful? Give us feedback" icon="pi pi-comment" styleClass="p-button-text" routerLink="/app/help"> </p-button>
  </div>
</div>
